/* ============================================================
 * ceremony-design-experience.js  (CERIMONIA-07F)
 * Landing "Home Cerimonia" — Claude Design, Shopify-safe.
 *
 * 07F changes:
 *  - Scroll transformation + 360 abito ENTRAMBI a frame-sequence
 *    <img> swapping (niente video scrub fragile).
 *  - Le URL dei frame arrivano da array JSON reali generati in Liquid
 *    via asset_url (<script type="application/json" data-cer-*-frames>),
 *    così nel Network compaiono richieste reali ai .webp.
 *
 * 07G: rimossi i debug counter temporanei (setText su [data-dbg-*]);
 *      la logica di fallback/preload resta invariata.
 *
 * Regole invariate:
 *  - init solo dentro [data-ceremony-design-root]; query sempre rooted.
 *  - mai body/html; nessun preventDefault su scroll/wheel/touchmove.
 *  - IntersectionObserver per gating; prefers-reduced-motion rispettato.
 *  - nessuna libreria esterna, nessun fetch esterno, nessun CDN.
 * ============================================================ */
(function () {
  "use strict";

  var REDUCED = false;
  try {
    REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch (e) {}

  function clamp(v, lo, hi) {
    return v < lo ? lo : v > hi ? hi : v;
  }

  // Parse a JSON array of frame URLs from a <script type="application/json"> child.
  function readFrames(scopeEl, attr) {
    var node = scopeEl.querySelector("[" + attr + "]");
    if (!node) return [];
    try {
      var arr = JSON.parse(node.textContent.trim());
      return arr && arr.length ? arr : [];
    } catch (e) {
      return [];
    }
  }

  // Preload an array of image URLs, reporting progress + failures.
  function preload(urls, onProgress) {
    var loaded = 0,
      failed = 0;
    urls.forEach(function (u) {
      var im = new Image();
      im.onload = function () {
        loaded++;
        if (onProgress) onProgress(loaded, failed);
      };
      im.onerror = function () {
        failed++;
        if (onProgress) onProgress(loaded, failed);
      };
      im.src = u;
    });
  }

  /* ============================================================
   * REVEAL + STAGGER
   * ============================================================ */
  function initReveal(root) {
    var nodes = root.querySelectorAll("[data-cer-reveal]");
    if (!nodes.length) return;

    var groups = root.querySelectorAll("[data-cer-stagger]");
    for (var g = 0; g < groups.length; g++) {
      var kids = groups[g].children;
      for (var k = 0; k < kids.length; k++) kids[k].style.setProperty("--i", k);
    }

    if (REDUCED || !("IntersectionObserver" in window)) {
      for (var n = 0; n < nodes.length; n++) nodes[n].classList.add("is-visible");
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    for (var i = 0; i < nodes.length; i++) io.observe(nodes[i]);
  }

  /* ============================================================
   * SFONDO TRASFORMATIVO A TUTTA PAGINA — xform frames.
   * Lo sfondo (.cer-bg) è sticky e copre la viewport; l'avanzamento
   * del frame è guidato dallo scroll dell'INTERA landing (root):
   * progress 0 in cima, 1 in fondo → frame 1..54.
   * ============================================================ */
  function initBg(root) {
    var bg = root.querySelector("[data-cer-bg]");
    if (!bg) return;
    var img = bg.querySelector(".cer-bg__frame");
    if (!img) return;

    var frames = readFrames(bg, "data-cer-xform-frames");
    var count = frames.length;

    function showFallback() {
      bg.classList.add("is-fallback");
    }

    if (count < 2) {
      showFallback();
      return;
    }

    img.src = frames[0];

    preload(frames, function (loaded, failed) {
      if (failed > count * 0.4) showFallback();
    });

    if (REDUCED) {
      // Static first frame, no scrubbing (rispetta reduce-motion).
      return;
    }

    var ticking = false;
    var lastIdx = 0;

    function render() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var total = rect.height - vh;
      var p = total > 0 ? clamp((0 - rect.top) / total, 0, 1) : 0;
      var idx = clamp(Math.round(p * (count - 1)), 0, count - 1);
      if (idx !== lastIdx) {
        lastIdx = idx;
        img.src = frames[idx];
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(render);
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    render();
  }

  /* ============================================================
   * 360 ABITO — product frames, drag/touch <img> swap
   * ============================================================ */
  function init360Frames(root) {
    var viewers = root.querySelectorAll("[data-cer-360]");
    for (var v = 0; v < viewers.length; v++) setup360(viewers[v], root);
  }

  function setup360(el, root) {
    var img = el.querySelector(".cer-360__frame");
    if (!img) {
      el.classList.add("is-fallback");
      return;
    }
    var frames = readFrames(el, "data-cer-360-frames");
    var count = frames.length;

    function fallback() {
      el.classList.add("is-fallback");
    }

    if (count < 2) {
      fallback();
      return;
    }

    var cur = 0;
    img.src = frames[0];

    preload(frames, function (loaded, f) {
      if (f > count * 0.4) fallback();
    });

    var dragging = false;
    var startX = 0;
    var startIdx = 0;

    function setFrame(idx) {
      idx = ((idx % count) + count) % count;
      if (idx !== cur) {
        cur = idx;
        img.src = frames[cur];
      }
    }

    function onDown(e) {
      dragging = true;
      el.classList.add("is-dragging");
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      startIdx = cur;
    }
    function onMove(e) {
      if (!dragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      var w = el.clientWidth || 1;
      var dx = x - startX;
      setFrame(startIdx + Math.round((dx / w) * count)); // one width = one full spin
    }
    function onUp() {
      if (!dragging) return;
      dragging = false;
      el.classList.remove("is-dragging");
    }

    el.addEventListener("mousedown", onDown);
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
    // touch-action: pan-y (CSS) → scroll verticale resta del browser.
    el.addEventListener("touchstart", onDown, { passive: true });
    el.addEventListener("touchmove", onMove, { passive: true });
    el.addEventListener("touchend", onUp);
    el.addEventListener("touchcancel", onUp);

    // Gentle auto-rotate when on-screen + idle (skip if reduced motion).
    if (REDUCED || !("IntersectionObserver" in window)) return;
    var raf = null,
      onScreen = false,
      idleUntil = 0,
      lastT = 0;

    function now() {
      return window.performance && performance.now ? performance.now() : 0;
    }
    function loop(t) {
      if (!onScreen) {
        raf = null;
        return;
      }
      // Auto-rotazione lenta e fluida: 1 frame ogni ~95ms (~10.5 fps).
      // Con 90 frame = ~9s per giro completo, passi angolari fini → morbido.
      if (!dragging && t > idleUntil && t - lastT > 95) {
        lastT = t;
        setFrame(cur + 1);
      }
      raf = window.requestAnimationFrame(loop);
    }
    var io = new IntersectionObserver(
      function (entries) {
        onScreen = entries[0].isIntersecting;
        if (onScreen && !raf) {
          lastT = 0;
          raf = window.requestAnimationFrame(loop);
        }
      },
      { threshold: 0.25 }
    );
    io.observe(el);

    function bumpIdle() {
      idleUntil = now() + 2600;
    }
    el.addEventListener("mousedown", bumpIdle);
    el.addEventListener("touchstart", bumpIdle, { passive: true });
  }

  /* ============================================================
   * BOOT
   * ============================================================ */
  function boot() {
    var roots = document.querySelectorAll("[data-ceremony-design-root]");
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      if (root.__cerInit) continue;
      root.__cerInit = true;
      root.classList.add("cer-js");
      try {
        initReveal(root);
        initBg(root);
        init360Frames(root);
      } catch (err) {
        if (window.console && console.warn) console.warn("[ceremony-design] init skipped:", err);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
